import { IReason } from "Model/IReason";
import { removeAllAttachments } from "Store/AssetManagement/UploadAttachments/UploadAttachmentsAction";
import RequisitionAction from "Store/Component/Requisition/RequisitionAction";
import { InputField, ReactSelectBox, Tooltip } from "client/CommonComponents";
import { CONSTANTS } from "./constants";

export const initializeReason = (request: any, nextReasonIndex: any) => {
    const reason: IReason = {
        isDisabled: false,
        requestIndex: request?.requestIndex,
        requestType: request?.requestType,
        reasonIndex: nextReasonIndex,
        reasonId: 0,
        reasonTypeId: 0,
        reasonType: "",
        shipToLocation: "",
        newEmployeeBusiness: "",
        jobIdOrEmpId: "",
        jobOrEmpName: "",
        salesAmount: "",
        asset: "",
        unitNumber: "",
        netBookedValue: "",
        mileageHourMeter: "",
        conditionId: 0,
        condition: "",
        dispositionTypeId: 0,
        dispositionType: "",
        statusId: 0,
        status: "",
        description: "",
        modelYear: "",
        replacementAssetDisposalDate: "",
        comments: "",
        commentsError : "",
        isValid: false,
        // isItemValid: false,
        attachments: [],
        attachmentsError: "",
        anticipatedDisposalPrice: "",
        reason: "",
        //validation
        reasonTypeError: '',
        shipToDealerError: '',
        //validation - growth
        newEmployeeBusinessError: '',
        jobIdOrEmpIdError: '',
        jobOrEmpNameError: '',
        salesAmountError: '',
        //planned & unplanned
        mileageHourMeterError: '',
        anticipatedDisposalPriceError: '',
        anticipatedDisposalPriceLengthError: '',
        reasonError: '',
        conditionError: '',
        assetError: '',
        isValidAsset: false,
        isReasonChanged: false,
        ///managed equipment quote price fields
        quotePrice: "",
        quotePriceError: "",
        estimatedPrice: "",
        name: "",
        nameError: "",
        contact: "",
        contactError: "",
        phone: "",
        phoneError: "",
        email: "",
        emailError: "",
        addressLine1: "",
        addressLine1Error: "",
        addressLine2: "",
        addressLine2Error: "",
        addressLine3: "",
        addressLine3Error: "",
        city: "",
        cityError: "",
        state: "",
        stateError: "",
        zipCode: "",
        zipCodeError: "",
        showQuotePrice: request?.showQuotePrice,
        showNewEmployee: request?.showNewEmployee,
        hasQuoteAttached: false
    }

    return reason;
}

export const resetReason = (reason: IReason) => {
    reason.reasonId = 0;
    reason.reasonTypeId = 0;
    reason.reasonType = "";
    reason.shipToLocation = "";
    reason.newEmployeeBusiness = "";
    reason.jobIdOrEmpId = "";
    reason.jobOrEmpName = "";
    reason.salesAmount = "";
    reason.asset = "";
    reason.unitNumber = "";
    reason.netBookedValue = "";
    reason.mileageHourMeter = "";
    reason.conditionId = 0;
    reason.condition = "";
    reason.dispositionTypeId = 0;
    reason.dispositionType = "";
    reason.statusId = 0;
    reason.status = "";
    reason.modelYear = "";
    reason.replacementAssetDisposalDate = "";
    reason.description = "";
    reason.comments = "";
    reason.commentsError="";
    reason.isValid = false;
    
    reason.attachments = [];
    reason.anticipatedDisposalPrice = "";
    reason.reason = "";
    //validation
    reason.reasonTypeError = '';
    reason.shipToDealerError = '';
    //validation - growth
    reason.newEmployeeBusinessError = '';
    reason.jobIdOrEmpIdError = '';
    reason.jobOrEmpNameError = '';
    reason.salesAmountError = '';
    //planned & unplanned
    reason.mileageHourMeterError = '';
    reason.anticipatedDisposalPriceError = '';
    reason.anticipatedDisposalPriceLengthError = '';
    reason.reasonError = '';
    reason.conditionError = '';
    reason.assetError = '';
    reason.isValidAsset = false;
    reason.isReasonChanged = false;
    //managed equipment quote price fields
    reason.quotePrice= "";
    reason.quotePriceError= "";
    reason.estimatedPrice= "";
    return reason;
}

export const resetReasonDealerdetail = (reason: IReason) => {
  reason.name= "";
  reason.nameError= "";
  reason.contact= "";
  reason.contactError= "";
  reason.phone= "";
  reason.phoneError= "";
  reason.email= "";
  reason.emailError= "";
  reason.addressLine1= "";
  reason.addressLine1Error= "";
  reason.addressLine2= "";
  reason.addressLine2Error= "";
  reason.addressLine3= "";
  reason.addressLine3Error= "";
  reason.city= "";
  reason.cityError= "";
  reason.state= "";
  reason.stateError= "";
  reason.zipCode= "";
  reason.zipCodeError= "";
  return reason;
}

// Extract only numbers from a Given value
export const getOnlyNumbers = (item: any) => {
    if (!item) item = 0;
    return item.toString()?.replace(/[^\d.]|\.(?=.*\.)/g, "")
}

// Extract numbers or null from a Given value
export const getNumberOrNull = (item: any) => {
    if (item >= 0){
        return item
    } 
    return null
}

// Resets Order Request value
export const resetOrderRequest = (dispatch: any) => {
    dispatch(RequisitionAction.setSelectedRequisitionType(""));
    dispatch(RequisitionAction.setIRequest(""));
    dispatch(RequisitionAction.setIProductionVehicle([]));
    dispatch(RequisitionAction.setINonStandardEquipment([]));
    dispatch(RequisitionAction.setIManagementVehicle([]));
    dispatch(RequisitionAction.setIReason(""));
    dispatch(RequisitionAction.setCartIRequest(""));
    dispatch(RequisitionAction.setCartIProductionVehicle(""));
    dispatch(RequisitionAction.setCartINonStandardEquipment(""));
    dispatch(RequisitionAction.setCartIManagementVehicle(""));
    dispatch(RequisitionAction.setCartIReason(""));
    dispatch(RequisitionAction.setShowItemDetails(""));
    dispatch(RequisitionAction.setIsAddToCartClick(false));
    dispatch(RequisitionAction.setIsReasonChange(false));
    dispatch(RequisitionAction.setIOrderRequest(""));
    dispatch(RequisitionAction.isSubmitClick(false));
    dispatch(RequisitionAction.isSaveClick(false));
    dispatch(RequisitionAction.setOrderLeadrNumber(""));
    dispatch(RequisitionAction.setIsOrderCreationSuccess({}));
    dispatch(RequisitionAction.setIManagedEquipment(""));
    dispatch(RequisitionAction.setCartIManagedEquipment(""));
    dispatch(removeAllAttachments());
    dispatch(RequisitionAction.setOrderId(undefined));
}

export const commonFilterDropDown = (onClickValue: any, getValue: any, column: any, myOrderHandleChange: any, options: any, handleOrderClearSelectFilter: any, search: any) => {
    return (
        <div className="date-filter-wrapper" onClick={(e: any) => onClickValue && onClickValue(e)}>
          <Tooltip content={getValue()?.current} data-attribute="RequisitionUtil_Default_Tooltip">
            <ReactSelectBox
              placeholder={CONSTANTS.SELECT}
              name={column?.key}
              onChange={(e: any) => myOrderHandleChange(e, column?.key)}
              className="form-control"
              value={getValue()?.current ? { label: getValue()?.current, text: getValue()?.current } : { label: CONSTANTS.SELECT, text: CONSTANTS.SELECT }}
              options={options}
              isSearchable={true}
             data-attribute="RequisitionUtil_Default_SearchSelectBox" />
          </Tooltip>
          <i
            className="fa fa-times-circle-o"
            aria-hidden="true"
            onClick={() => handleOrderClearSelectFilter(search, getValue(), column)}
          ></i>
        </div>
      );
}

export const CustomTextFilterDiv = (props: any) => {
  const { orderPriceFilter, onChange } = props;
  return (
    <Tooltip content={orderPriceFilter} data-attribute="RequisitionUtil_Default_Tooltip_2">
      <InputField
        onChange={onChange}
        value={orderPriceFilter}
       data-attribute="RequisitionUtil_Default_Input" />
    </Tooltip>
  );
};